export default "__VITE_ASSET__697bd691__"